export type RawSVGAPIData = {
  id: number;
  data: string;
  uid: string;
};

export type SVGAPIData = Omit<RawSVGAPIData, 'id' | 'data'> & {
  status: 'loading' | 'loaded';
  uid: string;
  data?: string;
  hasBorderColor?: boolean;
  hideBorderColor?: boolean;
};
